module.exports = "../static/media/default_avatar.5bd8acb7.png";